import { render, staticRenderFns } from "./Studentregistration.vue?vue&type=template&id=40fcc568&"
import script from "./Studentregistration.vue?vue&type=script&lang=js&"
export * from "./Studentregistration.vue?vue&type=script&lang=js&"
import style0 from "./Studentregistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports